import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {gsap, TimelineMax} from "gsap";

/**
 * Created by Jerker Nord on 2021-07-16.
 */

export class TrueGritWildMultiplierRunner implements SimplePresentation {

    shouldRun():boolean {
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {

        const mainTL:TimelineMax = gsap.timeline({onComplete : () => controller.finish()});
        mainTL.add(() => TrueGrit.symbolBoxView.setWildMultiplierText("x" + (TrueGrit.model.botTrain.wildMult).toString()));
        mainTL.add(() => TrueGrit.trueGritGritGirlSymbols.setMultiplierOnAllActiveSyms(TrueGrit.model.botTrain.wildMult));

        if(mainTL.duration() == 0) {
            mainTL.add(gsap.to(this, {duration : 0.001}));
        }
    }
}